export var openPopupWindow = function(href, title) {
    // Opens a new window to login with a social network account
    var width = 500;
    var height = 500;
    // Allow for borders.
    var leftPosition = window.screen.width / 2 - (width / 2 + 10);
    // Allow for title and status bars.
    var topPosition = window.screen.height / 2 - (height / 2 + 50);
    // Open the window.
    window.open(href, title, // eslint-disable-next-line max-len
    "status=no,height=".concat(height, ",width=").concat(width, ",resizable=yes,left=").concat(leftPosition, ",top=").concat(topPosition, ",screenX=").concat(leftPosition, ",screenY=").concat(topPosition, ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no"));
};
export var closePopupWindow = function(href) {
    var reload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    window.opener.location.reload(reload);
    window.opener.location.href = href;
    window.close();
};
